export default "__VITE_ASSET__da2e5767__"